export const headerContent = {
    en: {
        pricing: "Store",
        subscription: "Subscription",
        about: "For Physios",
        sign_in: "Sign In",
        sign_up: "Sign Up",
    },
    sl: {
        pricing: "Trgovina",
        subscription: "Naročnina",
        about: "Za fizioterapevte",
        sign_in: "Prijava",
        sign_up: "Registracija",
    }
} as const;